import React from 'react';
import ReactDOM from 'react-dom/client';
import TdxAdminMain from './TdxAdminMain';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/stokeStyle.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@mdi/font/css/materialdesignicons.min.css';


import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* ✅ Router로 감싸기 */}
      <AuthProvider>
        <TdxAdminMain />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

